import { ReactNode } from 'react';
import styles from './PreviewCard.module.css';

const PreviewCard = ({ children }: { children: ReactNode }) => {
    return <div className={styles.wrapper}>{children}</div>;
};

export default PreviewCard;
